import React from "react";
import { cx } from "../../utils";

export type ImageProps = React.ImgHTMLAttributes<HTMLImageElement> & { imagePath?: string; variant?: "content" | "fluid" | "preview" };
export function Image({ imagePath, src, alt = "", className, variant = "content", ...props }: ImageProps) {
  return <img src={src || imagePath} alt={alt} className={cx("h-auto object-contain", variant !== "preview" && "max-w-full",
    variant === "content" && "max-h-[600px]", variant === "preview" && "max-h-[90vh] max-w-[90vw]", className)} {...props} />;
}
